import styled from 'styled-components';
import { body2Medium, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { Label } from '../MetricTile.styled';
import { Container } from '../styled';

export const MetricsWrapper = styled.div`
  display: flex;
  padding: ${pxToRem(0)} ${pxToRem(24)};
  align-items: flex-start;
  align-self: stretch;
`;

export const JourneyEventsContainer = styled(Container)`
gap: ${pxToRem(24)};
`;

export const ProjectsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const ProjectsHeaderWrapper = styled.div`
  display: flex;
  padding: ${pxToRem(8)} ${pxToRem(16)};
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledHeaderColumn = styled.div`
  display: flex;
  height: ${pxToRem(20)};
  align-items: center;
  gap: ${pxToRem(4)};

  color: ${colors.textSecondary};
  font-size: ${pxToRem(11)};
  font-style: normal;
  font-weight: 700;
  line-height: ${pxToRem(12)};
  letter-spacing: ${pxToRem(2)};
  text-transform: uppercase;
`;

export const ProjectsRowsWrapper = styled.div`
  & > *:nth-of-type(odd) {
    background-color: ${colors.grey1};
  }

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

export const StyledRow = styled.div`
  display: flex;
  height: ${pxToRem(48)};
  padding: ${pxToRem(0)} ${pxToRem(16)};
  align-items: center;
  align-self: stretch;
`;

export const StyledProjectName = styled.div`
  width: ${pxToRem(549)};
`;

export const StyledEventsCount = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${pxToRem(8)};
  flex: 1 0 0;
`;

export const YearlyMetricCountLabel = styled(Label)`
color: ${colors.grey80};
font-size: ${pxToRem(14)};
font-style: normal;
font-weight: 700;
line-height: ${pxToRem(20)};
letter-spacing: 0.1px;
`;

export const MonthlyMetricCountLabel = styled(Label)`
color: ${colors.grey80};
font-size: ${pxToRem(24)};
font-style: normal;
font-weight: 700;
line-height: ${pxToRem(28)};
letter-spacing: -0.25px;
`;

export const StyledMetricCount = styled.div`
display: flex;
align-items: flex-end;
gap: ${pxToRem(8)};
align-self: stretch;
height: ${pxToRem(28)};
`;

export const MetricCountWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: ${pxToRem(4)};
align-self: stretch;
`;

export const AnalyticsCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${pxToRem(12)};
  flex: 1 0 0;
`;

export const AnalyticsCardLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${pxToRem(2)};
`;

export const AnalyticsCardLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${pxToRem(8)};
  ${body2Medium};
  color: ${colors.textSecondary};
  white-space: nowrap;
`;
